<template>
  <div class="w-full h-full" v-show="showChats">
    <SelectedContact />
    <div class="cust-message-h bg-whatsapp-doodle hello-height">
      <div class="pt-3 cust-chat-befinput">
        <MessageItem v-for="(message, index) in messages" :key="'message-' + index" :message="message" />
      </div>
      <div class="">
      </div>
      <!-- {{ checkdisabledd() }} -->
    </div>
    <MessageInput @messageSent="scrollToElement" :checkdisabled="disabled" />
  </div>
</template>
<script>
import MessageItem from "./MessageItem";
import MessageInput from "./MessageInput";
import SelectedContact from "../Contacts/SelectedContact";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import leadMixin from "../../mixins/leadMixin";

//Styles
import "../../assets/sass/main.scss";

export default {
  data() {
    return {
      disabled: false
    }
  },
  mixins: [leadMixin],
  components: {
    MessageItem,
    MessageInput,
    SelectedContact,
  },
  computed: {
    ...mapGetters("whatsappChat", {
      messages: "messages",
      activeChat: "activeChat",
      showChats: "showChats",
    }),
    ...mapState("AgentRouting", {
      rmrecord: "rmrecord",
      assignrmname: "assignrmname",
      getassigned: "getassigned",
      assignStatus: "assignStatus",
      allassignagent: "allassignagent",
      assignmono:"assignmono"

    }),
  },
  watch: {
    messages() {
      setTimeout(() => {
        this.scrollToElement();
      }, 100);
    },
    activeChat() {
      this.disabled = false
      this.checkdisabledd()

    }
  },
  methods: {
    checkdisabledd() {
      this.allassignagent.map((val) => {
        if (val.usermno == this.activeChat.phone) {
          let curdate = new Date();
          let timediff = Math.abs(curdate.getTime() - new Date(val.updatedAt).getTime());
          let hours = Math.floor(timediff / (1000 * 60 * 60));
          console.log(val.isreply, "hourshourshourshours")

          if (Number(hours) > 24 && val.isreply == false) {
            return this.disabled = true
          }
        }
      });
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("message-item");
      const elem = el[el.length - 1];
      if (elem) {
        elem.scrollIntoView();
      }
    },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      // this.isConnected = true;
    },
    disconnect() {
      // Fired when the socket disconnects.
      // this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChange" channel.
    async messageChange(data) {
      console.log("trueeeeeeeeeee")
      const payload = {
        phone: data.payload.destination || data.payload.source,
      };
      if(payload){
        await this.$store.dispatch("whatsappChat/Updatecontact", payload);
      const payload2 = {};
      if (this.assignmono.length > 0) {
        Object.assign(payload2, { number: this.assignmono[0].assignedNumber });
      }
      let responce = await this.$store.dispatch(
        "whatsappChat/fetchContacts",
        payload2
      );
      }
   
      // if (!data.payload.sender) return;
      // this.addLead(data.payload.sender.name, data.payload.sender.phone);
      console.log(data.payload.receiver);
      console.log(
        data.type == "message" &&
        data.payload.receiver === this.activeChat.phone
      );
      let temp =
        data.payload.receiver && data.payload.id === "BOT_MESSAGE"
          ? data.payload.receiver
          : data.payload.sender.phone;

      console.log(
        data.payload.receiver
          ? data.payload.receiver
          : data.payload.sender.phone,
        "TEMP"
      );
      if (temp === this.activeChat.phone) {
        this.$store.commit("whatsappChat/ADD_NEW_MESSAGE", data);
      }
      if (
        (data.payload.sender.phone || data.payload.receiver) !==
        this.activeChat.phone
      ) {
        await this.$store.commit(
          "whatsappChat/INCREMENT_NOTIFICATION",
          data.payload.sender
        );
      }

      if (
        data.payload.payload.text === "3" ||
        data.payload.payload.text === "4"
      ) {
        this.$store.dispatch("whatsappChat/agent");

        this.$vs.notify({
          title: `${data.payload.sender.name}`,
          text:
            data.payload.payload.text === "3"
              ? ` wants to buy a trial pack`
              : ` wants to talk to an agent`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-right",
        });
      }
      // this.socketMessage = data
      this.scrollToElement();
    },
  },
};
</script>
<style>
.disabledd {
  cursor: not-allowed;
}

/* .cust-chat-befinput {
  height: 90vh;
}

.hello-height {
  height: 70vh !important;
} */
</style>
